import { render } from "./PhonePart2.vue?vue&type=template&id=e357007c"
import script from "./PhonePart2.vue?vue&type=script&lang=js"
export * from "./PhonePart2.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__